import Vue from "vue"
import Router from "vue-router"
import custom from "@/router/custom"
import template from "@/router/template"
import { getCookie } from "@/apis/cookie";
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
let homePath
let roleType = localStorage.getItem('roleType')
if(getCookie('admin-token')){
  if (roleType == 0 || roleType == 1 ) {
    homePath = 'agentOverview' //管理员跳转首页
  } else {
    homePath = 'agentBoard' //经纪人跳转首页
  }
} else{
  homePath = 'noLogin' //未登录
}
const myRouter = new Router({
  mode: "history",
  routes: [
    ...custom,
    {
      path: "/",
      redirect: homePath,
      name: homePath,
      component: () => import("@/templateArch/index"),
      children: template
    },
    {
      path: '*',
      component: () => import('@/viewsCustom/error_500'),
    }
  ]
})
myRouter.beforeEach((to, from, next) => {
  if (to.meta.type && to.meta.type === "custom") {
    next()
  } else {
    next()
  }
})
export default myRouter
